import { formatDateUTC } from "../../util";
import { underscoreToTitleCase } from "../../../../utils";

const SOURCE_FIELD_MAPPINGS = {
  created: "Time",
  url: "URL",
  filename: "File Name",
  released: "Date"
};

const fieldOrder = ["URL", "File Name", "Date", "Record Time", "Time", "Host"];

const checkForDateConversion = (key, value) =>
  ["released", "record_time", "created"].includes(key)
    ? formatDateUTC(value)
    : value;

export const formatSourcesDataForDisplay = data => {
  const formatedData = {};

  Object.entries(data).forEach(([sourceKey, sourceValue]) => {
    if (sourceValue.length || Object.keys(sourceValue).length) {
      if (sourceKey === "uuid") {
        return;
      }
      if (sourceKey in SOURCE_FIELD_MAPPINGS) {
        formatedData[SOURCE_FIELD_MAPPINGS[sourceKey]] = checkForDateConversion(
          sourceKey,
          sourceValue
        );
      } else {
        const newKey = underscoreToTitleCase(sourceKey);
        formatedData[newKey] = checkForDateConversion(sourceKey, sourceValue);
      }
    }
  });

  const sortedData = Object.entries(formatedData);

  sortedData.sort((a, b) => {
    const idx1 = fieldOrder.indexOf(a[0]);
    const idx2 = fieldOrder.indexOf(b[0]);
    return (idx1 > -1 ? idx1 : Infinity) - (idx2 > -1 ? idx2 : Infinity);
  });

  return sortedData;
};

export const filterUrlFromSources = sources => {
  const { ticloud_sources, other_sources } = sources || {};

  const tiCloudSourcesArr =
    ticloud_sources?.entries
      ?.flatMap(item => item?.properties || [])
      .filter(({ name, value }) => name === "url" && value !== "")
      .map(({ value }) => ({ value })) || [];

  const otherSourcesArr =
    other_sources?.flatMap(otherSourcesItem => {
      const { host, url } = otherSourcesItem || {};

      if (host && url) {
        return [{ value: host }, { value: url }];
      }
      if (host) {
        return [{ value: host }];
      }
      if (url) {
        return [{ value: url }];
      }

      return [];
    }) || [];

  const urls = [...tiCloudSourcesArr, ...otherSourcesArr];

  // Return uniq urls
  return [...new Map(urls.map(v => [v.value, v])).values()];
};
